import { globalDef } from "../siteDefinitions";
import { AccountValidation } from "../validation/AccountValidation";

export class AccountForm {
    private accountValidation = new AccountValidation(this.accountCreationForm);

    constructor(private accountCreationForm: HTMLFormElement) {
        this.accountCreationForm.noValidate = true;

        this.accountCreationForm.addEventListener("submit", (event) => {
            event.preventDefault();
            const valid = this.accountValidation.validateAllFields();

            if (!valid) {
                return;
            }

            if (!globalDef.cmnDebug) {
                grecaptcha.execute();
            } else {
                this.submitCreateUser();
            }
        });

        if (!globalDef.cmnDebug && document.getElementById("g-recaptcha")) {
            window.addEventListener("loadAccountRecaptcha", this.loadAccountRecaptcha);
        }
    }

    private loadAccountRecaptcha = () => {
        grecaptcha.render("g-recaptcha", {
            sitekey: "6LfoeqIUAAAAAJDliNy2Pfo5AnowXsGTOCpyj_Xp",
            callback: this.submitCreateUser,
            size: "invisible",
        });
    };

    private submitCreateUser = async () => {
        this.accountCreationForm.classList.add("account-form--submitting");

        const formData = new FormData(this.accountCreationForm);

        if (!globalDef.cmnDebug) {
            formData.append("g_recaptcha_response", grecaptcha.getResponse());
        }

        const user = await this.createUser(formData);

        if (user?.account !== "created") {
            this.accountCreationForm.classList.remove("account-form--submitting");
            return this.accountValidation.manualValidation(user);
        }

        location.href = `/your-account/?action=account-verification-sent`;
    };

    /**
     * Send an ajax request to the server
     */
    private createUser = (formData: FormData) => {
        return new Promise<any>((resolve, reject) => {
            $.ajax({
                url: `${globalDef.ajaxFunctionsUrl}function=create-user`,
                cache: false,
                type: "POST",
                processData: false,
                contentType: false,
                data: formData,
                success(response) {
                    resolve(JSON.parse(response));
                },
                error(error) {
                    reject(error);
                },
            });
        });
    };
}
